import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = () => {
  const domain = 'https://chequefill.homy.hk';
  const title = '支票寫法與大寫轉換 2026：數字轉中英文金額工具 | Cheque Fill';
  const description = 'Cheque Fill 是免費的香港支票金額大寫轉換工具，可即時把阿拉伯數字轉為繁體中文正寫、英文支票金額及多國語言格式，並提供複製、格式化數字和支票填寫指南；所有轉換均在瀏覽器本地完成，不會上傳或儲存金額資料，適合支票、合約、發票及跨境商務文件使用。';
  const image = `${domain}/favicon.svg`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${domain}/#website`,
        name: 'Cheque Fill',
        url: `${domain}/`,
        inLanguage: 'zh-HK',
        description,
        publisher: {
          '@id': `${domain}/#organization`
        }
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${domain}/#application`,
        name: 'Cheque Fill',
        url: `${domain}/`,
        description,
        applicationCategory: 'FinanceApplication',
        applicationSubCategory: 'Cheque amount converter',
        operatingSystem: 'Any',
        browserRequirements: 'Requires JavaScript and a modern web browser',
        inLanguage: [
          'zh-HK',
          'zh-CN',
          'ko-KR',
          'en-US',
          'en-GB',
          'de-DE',
          'es-ES',
          'fr-FR',
          'it-IT',
          'ar-AE',
          'th-TH'
        ],
        dateModified: '2026-03-07',
        isAccessibleForFree: true,
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'HKD',
          availability: 'https://schema.org/InStock'
        },
        featureList: [
          '香港繁體中文支票金額正寫',
          '英文支票金額轉換',
          '多國語言金額參考',
          '格式化數字及一鍵複製',
          '瀏覽器本地轉換'
        ],
        author: {
          '@id': `${domain}/#organization`
        }
      },
      {
        '@type': 'Organization',
        '@id': `${domain}/#organization`,
        name: 'Homy Tech',
        url: 'https://homy.hk/',
        sameAs: [
          'https://www.threads.com/@homy.hk',
          'https://www.instagram.com/homy.hk',
          'https://www.facebook.com/profile.php?id=61578745554661'
        ]
      },
      {
        '@type': 'FAQPage',
        '@id': `${domain}/#faq`,
        mainEntity: [
          {
            '@type': 'Question',
            name: '2026 年香港支票大寫的正確格式？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '在香港，支票金額大寫通常使用繁體正寫，例如壹、貳、叁。整數金額後補上圓正；英文整數金額則以 Only 結尾。'
            }
          },
          {
            '@type': 'Question',
            name: '為什麼支票寫法不能有空格？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '書寫大寫金額時應緊貼左側貨幣字樣，並避免留下明顯空隙，以降低他人添加文字或篡改金額的風險。'
            }
          },
          {
            '@type': 'Question',
            name: 'Cheque Fill 支援哪些貨幣與語言？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Cheque Fill 提供繁體中文、簡體中文、英文、韓文、德文、法文、西班牙文、意大利文、阿拉伯文及泰文等語言的金額轉換參考。'
            }
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <html lang="zh-HK" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="支票寫法,支票大寫,數字轉大寫,中英文金額轉換,香港支票格式,支票金額英文,財務工具,Homy Tech,Cheque Fill"
      />
      <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" />

      <meta property="og:locale" content="zh_HK" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Cheque Fill" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${domain}/`} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="Cheque Fill 支票金額大寫轉換工具標誌" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="Cheque Fill 支票金額大寫轉換工具標誌" />

      <link rel="canonical" href={`${domain}/`} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;